// Entry point for the build script in your package.json
import Promise from 'bluebird';
import 'sweetalert2/dist/sweetalert2.css';
import NotificationsHelper from '../app/notifications_helper';
import initRangeSliders from '../app/rangeslider';
import _ from 'lodash';

window._ = _; // Make lodash available globally

Promise.config({ cancellation: true });

export default class App {
  static notify(...params) { NotificationsHelper.notify.apply(this, params); }
  static initRangeSliders() { initRangeSliders(); }
}

window.App = App;

$(document).on('ready turbolinks:load', () => {
  NotificationsHelper.loadMessages();
});

// Require all files inside ./
import.meta.glob('../**/*.js', { eager: true });
import.meta.glob('../**/*.jsx', { eager: true });
